var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#00361F;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M104.5,45.5c-32.53271,0-59,26.46777-59,59V466.5H407.5c32.53271,0,59-26.46777,59-59V45.5H104.5Zm0,21H445.5v81.59961H66.5v-43.59961c0-20.95312,17.04688-38,38-38Zm95.3335,145.04199v-42.44238h112.3335v42.44238h-112.3335Zm112.3335,21v42.44238h-112.3335v-42.44238h112.3335Zm-133.3335-21H66.5v-42.44238h112.3335v42.44238Zm0,21v42.44238H66.5v-42.44238h112.3335Zm0,63.44238v42.44238H66.5v-42.44238h112.3335Zm21,0h112.3335v42.44238h-112.3335v-42.44238Zm133.3335,0h112.33301v42.44238h-112.33301v-42.44238Zm0-21v-42.44238h112.33301v42.44238h-112.33301Zm0-63.44238v-42.44238h112.33301v42.44238h-112.33301Zm74.33301,233.95801H66.5v-86.07324H445.5v48.07324c0,20.95312-17.04688,38-38,38Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 134.02002,
    y: 390.86914,
    width: 243.95996,
    height: 21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.50c699063cb5d801b02f375ced32523b.svg";
export { ForwardRef as ReactComponent };